import { CellText, PhoneNumbersLinker } from '@/_containers';
import type { PhoneNumberQuerySchema } from '@/_schemas/phone-numbers';
import { noop } from '@/_shared';

type CellPhoneNumbersProps = {
  phoneNumbers?: PhoneNumberQuerySchema[];
};

export function CellPhoneNumbers({ phoneNumbers = [] }: CellPhoneNumbersProps) {
  if (phoneNumbers.length === 0) {
    return <CellText>—</CellText>;
  }

  return <PhoneNumbersLinker phone_numbers={phoneNumbers} removeItemHandler={noop} isEditable={false} />;
}
